import React from 'react';
import './footer.scss';

import { Link } from 'gatsby';
import { AppStateContext } from '../contexts/app-state-provider.context';
import { TranslatableText, TranslatedBlock } from './language';

import IMCLogoEN from 'src/images/IMC_logo_EN.svg';
import IMCLogoFR from 'src/images/IMC_logo_FR.svg';
import PAABLogoEN from 'src/images/PAAB_logo_color_EN.png';
import PAABLogoFR from 'src/images/PAAB_logo_color_FR.png';
import EnspryngLogo from 'src/images/ENSPRYNG_logo.svg';

export default class Footer extends React.Component {
  static contextType = AppStateContext;

  handleCookiePreferencesClick = event => {
    event.stopPropagation();
    window.OneTrust.ToggleInfoDisplay();
  };

  render() {
    let rpgCodeDict = null;
    const section = this.context.section;

    if (section === 'patient') {
      rpgCodeDict = {
        english: '19106E26v',
        french: '19106F26v',
      };
    } else if (section === 'hcp') {
      rpgCodeDict = {
        english: '19106E26v',
        french: '19106F26v',
      };
    } else {
      rpgCodeDict = {
        english: '19106E26v',
        french: '19106F26v',
      };
    }
    const rpgCode = rpgCodeDict ? (
      <div className="container rpg-code-container">
        <div className={'rpg-code'}>
          <TranslatableText dictionary={rpgCodeDict} />
        </div>
      </div>
    ) : null;

    return (
      <AppStateContext.Consumer>
        {() => (
          <footer id="colophon" className="site-footer login-footer">
            <div className="site-info">
              <div className="container-fluid footer-container">
                <div className="container">
                  <TranslatedBlock language="english">
                    <Link to="https://rocheterms.ca/en/terms-and-conditions/" className="footer-link" target="_blank">
                      Terms & Conditions
                    </Link>
                  </TranslatedBlock>
                  <TranslatedBlock language="french">
                    <Link to="https://rocheterms.ca/fr/terms-and-conditions/" className="footer-link" target="_blank">
                      Conditions d'utilisation
                    </Link>
                  </TranslatedBlock>
                  <TranslatedBlock language="english">
                    <Link to="https://rocheterms.ca/en/privacy-policy/" className="footer-link" target="_blank">
                      Privacy Policy
                    </Link>
                  </TranslatedBlock>
                  <TranslatedBlock language="french">
                    <Link to="https://rocheterms.ca/fr/privacy-policy/" className="footer-link" target="_blank">
                      Énoncé de confidentialité
                    </Link>
                  </TranslatedBlock>

                  <button className="footer-link ot-sdk-show-settings" onClick={this.handleCookiePreferencesClick}>
                    <TranslatableText
                      dictionary={{
                        english: 'Cookie Preferences',
                        french: 'Préférences en matière de témoins',
                      }}
                    />
                  </button>
                </div>
              </div>
              <div className="container">
                <TranslatedBlock language="english">
                  <div className="aes-reporting-disclaimer">
                    <div className="resizable">
                      This website is neither intended nor designed to record or report adverse event information. If
                      you have a suspected side effect or problem to report regarding a Roche product, please email
                      mississauga.canada_medinfo@roche.com or call 1-888-762-4388. You can also report adverse events
                      relating to any product to Health Canada directly by going to the Canada Vigilance Program website
                      at
                      https://www.canada.ca/en/health-canada/services/drugs-health-products/medeffect-canada/adverse-reaction-reporting.html.
                    </div>
                  </div>
                  <div className="additional-footer-info">
                    <div className="resizable"> © 2021−{new Date().getFullYear()}, Hoffmann-La Roche Limited</div>
                    <div className="resizable">
                      {' '}
                      ENSPRYNG<sup>®</sup> Registered trademark of Chugai Seiyaku Kabushiki Kaisha, used under license
                    </div>
                  </div>
                  <div className="footer-logos">
                    <img src={IMCLogoEN} alt="IMC logo" className={'imc-logo-img'} />
                    <img src={PAABLogoEN} alt="PAAB logo" className={'paab-logo-img'} />
                  </div>
                  <div className="enspryng-footer-logo">
                    <img src={EnspryngLogo} alt="ENSPRYNG logo" />
                  </div>
                </TranslatedBlock>
                <TranslatedBlock language="french">
                  <div className="aes-reporting-disclaimer">
                    <div className="resizable">
                      Ce site Web ne vise pas et n’a pas été conçu pour l’enregistrement ou la déclaration de
                      l’information sur les manifestations indésirables. Si vous devez déclarer un effet secondaire ou
                      un problème soupçonné concernant un des produits de Roche, veuillez envoyer un courriel à
                      mississauga.canada_medinfo@roche.com ou téléphoner au 1-888-762-4388. Vous pouvez aussi déclarer
                      les effets indésirables se rapportant à n’importe quel produit directement à Santé Canada en
                      visitant le site Web du Programme Canada Vigilance au
                      https://www.canada.ca/fr/sante-canada/services/medicaments-produits-sante/medeffet-canada/declaration-effets-indesirables.html.
                    </div>
                  </div>
                  <div className="additional-footer-info">
                    <div className="resizable">
                      {' '}
                      © 2021−{new Date().getFullYear()} Hoffmann-La Roche Limited/Limitée
                    </div>
                    <div className="resizable">
                      {' '}
                      ENSPRYNG<sup>®</sup> est une marque déposée de Chugai Seiyaku Kabushiki Kaisha, utilisée sous
                      licence.
                    </div>
                  </div>
                  <div className="footer-logos">
                    <img src={IMCLogoFR} alt="IMC logo" className={'imc-logo-img'} />
                    <img src={PAABLogoFR} alt="PAAB logo" className={'paab-logo-img'} />
                  </div>
                  <div className="enspryng-footer-logo">
                    <img src={EnspryngLogo} alt="ENSPRYNG logo" />
                  </div>
                </TranslatedBlock>
              </div>
              {rpgCode}
            </div>
          </footer>
        )}
      </AppStateContext.Consumer>
    );
  }
}
